module.exports = __webpack_public_path__ + "static/media/MaterialBreakdown-11.c4fec622.png";